import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SyncDataService {
  afterSuccessfulOperation = new Subject();

  getAfterSuccessfulOperation() {
    return this.afterSuccessfulOperation.asObservable();
  }
}
